import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
}));

function Loader(props) {
    const classes = useStyles();
    return (
        <Backdrop className={classes.backdrop} open={props.isLoading}>
            <CircularProgress color="inherit" />
        </Backdrop>
    );
}

export default Loader;